import { Button } from '@myhome/ui/components/button';
import { StatusBanner } from '@myhome/ui/patterns/status-banner';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AuthScreen } from '../components/auth-screen';
import { env } from '../env';
import { authClient, sessionQuery } from '../lib/auth-client';

export const Route = createFileRoute('/no-access')({
  component: NoAccessPage,
});

/**
 * Signed in, but not as an admin. The cookie is shared with app., so this is
 * usually a member or provider who followed the wrong link.
 */
function NoAccessPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: session } = useQuery(sessionQuery);

  const signOut = async () => {
    await authClient.signOut();
    queryClient.removeQueries({ queryKey: sessionQuery.queryKey });
    await navigate({ to: '/login', replace: true });
  };

  return (
    <AuthScreen title="This account can't use the back office">
      <StatusBanner
        tone="neutral"
        title="The back office is for MyHome+ staff"
        description={
          session?.user.email === undefined ? (
            'Members and providers use the MyHome+ app.'
          ) : (
            <>
              You are signed in as <span className="font-semibold break-all">{session.user.email}</span>.
              Members and providers use the MyHome+ app.
            </>
          )
        }
      />
      <Button asChild block>
        <a href={env.VITE_APP_ORIGIN}>Go to the MyHome+ app</a>
      </Button>
      <Button variant="outline" block onClick={signOut}>
        Sign out
      </Button>
      <p className="text-meta text-neutral-600">
        Signing out here also signs you out of the app on this browser.
      </p>
    </AuthScreen>
  );
}
